import { serverSideTranslations } from 'next-i18next/pages/serverSideTranslations'
import { DEFAULT_NAMESPACES } from 'constants/i18n'
import i18nConfig from 'utils/i18nConfig'
import Layout from 'components/layout/Layout'
import Complaint from 'features/complaint/Complaint'
import { useTranslation } from 'next-i18next/pages'
import { SeoProps } from 'components/seo/types'

const ComplaintPage = () => {
  const { t } = useTranslation('complaint')
  const seo: SeoProps = {
    title: t('seo.title'),
    description: t('seo.description')
  }

  return (
    <Layout {...{ seo }}>
      <Complaint />
    </Layout>
  )
}

export const getStaticProps = async ({ locale }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale, [...DEFAULT_NAMESPACES, 'complaint'], i18nConfig))
    }
  }
}

export default ComplaintPage
